import { useState } from 'react'

interface Column {
  key: string
  label: string
  render?: (value: any, row: any) => React.ReactNode
}

interface Props {
  columns: Column[]
  data: any[]
  onEdit: (item: any) => void
  onDelete: (item: any) => void
  loading?: boolean
}

export default function AdminTable({ columns, data, onEdit, onDelete, loading }: Props) {
  const [deleting, setDeleting] = useState<string | null>(null)

  const handleDelete = (item: any) => {
    if (deleting === item.id) {
      onDelete(item)
      setDeleting(null)
    } else {
      setDeleting(item.id)
      setTimeout(() => setDeleting(null), 3000)
    }
  }

  if (loading) {
    return <div className="text-center py-12 text-gray-400">Loading...</div>
  }

  if (!data.length) {
    return <div className="text-center py-12 text-gray-400">No items found</div>
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-white/10">
            {columns.map((col) => (
              <th key={col.key} className="text-left py-3 px-4 text-gray-400 font-medium">
                {col.label}
              </th>
            ))}
            <th className="text-right py-3 px-4 text-gray-400 font-medium">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.id} className="border-b border-white/5 hover:bg-white/5 transition-colors">
              {columns.map((col) => (
                <td key={col.key} className="py-3 px-4 text-white">
                  {col.render ? col.render(row[col.key], row) : String(row[col.key] ?? '')}
                </td>
              ))}
              <td className="py-3 px-4 text-right">
                <button
                  onClick={() => onEdit(row)}
                  className="text-electric-blue hover:text-electric-blue/80 mr-3 transition-colors"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(row)}
                  className={`transition-colors ${
                    deleting === row.id ? 'text-red-400 font-bold' : 'text-red-400/70 hover:text-red-400'
                  }`}
                >
                  {deleting === row.id ? 'Confirm' : 'Delete'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
